import { CheckCircle, AlertCircle } from "react-feather";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import "./styles.scss";
import { logOut } from "@store/authentification/actionCreator";
import { useDispatch } from "react-redux";
import { editCandidateDetails, deleteCandidate } from "@store/profile/actionCreator";
import { STRINGS } from "../../utility/_helpers/strings";
const logOutImg = require("@src/assets/images/icons/logout.png").default;

const AlertModalSecurity = ({ modal, setModal, message, type = "logout", title, setDeleteAccount, setDesactivateAccount }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toggle = () => setModal(!modal);

  const handleLogout = () => {
    if (type === "logout") {
      dispatch(logOut());
    } else if (type === "deactivate") {
      dispatch(editCandidateDetails({ isEnabled: false }, false, false, false, false, true));
    } else if (type === "delete") {
      dispatch(deleteCandidate());
    }
  };

  return (
    <div className={`theme-modal-${type} vertically-centered-modal`}>
      <Modal
        toggle={toggle}
        isOpen={modal}
        className={`modal-${type} modal-dialog-centered`}
        modalClassName={`modal-${type}`}
      >
        <ModalHeader>
          <Row className="d-flex flex-column align-items-center">
            {type === "logout" ? (
              <img src={logOutImg} alt="logout" className="mt-2"></img>
            ) : type === "error" || type === "recruiter" ? (
              <AlertCircle size={100} className=" mb-2" color="#FF0000" />
            ) : type === "resetPass" || type === "personal" ? (
              <CheckCircle className="mb-1 mt-3" size={128} color="#28C76F" />
            ) : (
              <AlertCircle className="mb-1 mt-3" size={128} color="#FF8A00" />
            )}
            <span className="title">{title ? title : null}</span>
          </Row>
        </ModalHeader>
        <ModalBody className="p-3">
          {type === "logout" ? (
            <div>
              <h2 className="text-center mb-1">{t("title_popup_logout")}</h2>
              <p className="text-center">{t("subtitle_popup_logout")}</p>
            </div>
          ) : type === "deactivate" ? (
            <div>
              <h2 className="text-center mb-1">{t("deactivate_account")}</h2>
              <p className="text-center">{t("text_deactivate_account")}</p>
            </div>
          ) : type === "delete" ? (
            <div>
              <h2 className="text-center mb-1">{t("delete_account")}</h2>
              <p className="text-center">{t("text_delete_account")}</p>
            </div>
          ) : (
            <span className="message">{message ? message : null}</span>
          )}

          {type === "mobility" ? (
            <Link className="link" to={{ pathname: "/mes-documents" }}>
              <Button className="mb-2" color={STRINGS.COLORS.DANGER}>
                {t("download")}
              </Button>
            </Link>
          ) : type === "exp" ? (
            <Button className="mb-2" color={STRINGS.COLORS.DANGER} onClick={toggle}>
              {t("validate")}
            </Button>
          ) : type === "resetPass" ? (
            <Button
              className="mb-2 rounded-pill"
              onClick={toggle}
              outline
              color={STRINGS.COLORS.DANGER}
            >
              {t("return")}
            </Button>
          ) : type === "recruiter" ? (
            <a className="link" href="mailto:support@valjob.ch?subject=Account disabled&body=Tapez votre message ici, nous reviendrons vers vous le plutôt possible">
              <Button.Ripple
                color={STRINGS.COLORS.DANGER}
                className="mr-1 mt-2"
              >
                {t("email")}
              </Button.Ripple>
            </a>
          ) : type === "personal" ? (
            <Link className="link" to={{ pathname: "/tableau-de-bord" }}>
              <Button.Ripple
                color={STRINGS.COLORS.DANGER}
                className="mr-1 mt-2"
              >
                {t('to_dashboard')}
              </Button.Ripple>
            </Link>
          ) : (
            <div className="card-action">
              <Button.Ripple
                outline
                color={STRINGS.COLORS.DANGER}
                className="ml-1 mr-1  mt-2"
                onClick={() => {
                  setDeleteAccount && setDeleteAccount(false)
                  setDesactivateAccount && setDesactivateAccount(false)
                  toggle()
                }}
              >
                {t("button_discard_popup")}
              </Button.Ripple>
              <Button.Ripple
                color={STRINGS.COLORS.DANGER}
                className={`mr-1 mt-2 ${type === 'logout' && 'logout-button'}`}
                onClick={handleLogout}
              >
                {type === "deactivate"
                  ? t("button_deactivate")
                  : type === "delete"
                    ? t("button_delete")
                    : t("button_submit_popup_logout")}
              </Button.Ripple>
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AlertModalSecurity;
